import { render, staticRenderFns } from "./modalDokumen.vue?vue&type=template&id=d687ad9a"
import script from "./modalDokumen.vue?vue&type=script&lang=js"
export * from "./modalDokumen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports